import React, { useState, useEffect } from "react";
import { Flex, Badge } from "@mantine/core";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export default function ReportRecipeStats({ recipe, color, size = "sm" }) {
  const [elapsedTime, setElapsedTime] = useState("");

  useEffect(() => {
    if (recipe.show_elapsed) {
      const updateElapsedTime = () => {
        const now = dayjs();
        const startedAt = dayjs(recipe.started_at);
        const elapsed = now.diff(startedAt, "seconds");
        const minutes = Math.floor(elapsed / 60);
        const seconds = elapsed % 60;
        const formatted =
          minutes > 0
            ? `${minutes}:${seconds.toString().padStart(2, "0")}`
            : `${seconds}s`;
        setElapsedTime(formatted);
      };

      // Update immediately
      updateElapsedTime();

      // Update every 2 seconds
      const interval = setInterval(updateElapsedTime, 1000);

      return () => clearInterval(interval);
    }
  }, [recipe.show_elapsed, recipe.started_at]);

  if (recipe.show_elapsed) {
    return (
      <Flex gap="xs" wrap="wrap">
        <Badge variant="light" color="gray" size={size}>
          Avg. run time: {formatTime(recipe.average_processing_time)}
        </Badge>
        <Badge variant="light" color="gray" size={size}>
          Elapsed: ~{elapsedTime}
        </Badge>
      </Flex>
    );
  }

  return (
    <Flex gap="xs" wrap="wrap">
      {recipe.run_count > 0 && (
        <Badge variant="light" color={color} size={size}>
          Runs: {recipe.run_count}
        </Badge>
      )}
      {typeof recipe.average_processing_time === "number" && (
        <Badge variant="light" color={color} size={size}>
          {recipe.setup ? "Completed in" : "Avg. run time:"}{" "}
          {formatTime(recipe.average_processing_time)}
        </Badge>
      )}
      {recipe.last_run_at && (
        <Badge variant="light" color={color} size={size}>
          Last ran {new Date(recipe.last_run_at).toLocaleString()}
        </Badge>
      )}
    </Flex>
  );
}

function formatTime(seconds) {
  return dayjs.duration({ seconds: seconds }).humanize();
}
